import SeparateQuantity from './SeparateQuantity';

export default SeparateQuantity;
